export type PlannerFamily = 'programmatic' | 'direct-sales';

export const getPlannerFamily = (pathname: string): PlannerFamily | null => {
  if (pathname.includes('/planner/programmatic')) return 'programmatic';
  if (pathname.includes('/planner/direct-sales')) return 'direct-sales';
  return null;
};

export const isPlannerPath = (pathname: string): boolean => getPlannerFamily(pathname) !== null;

export const isSamePlannerFamily = (fromPathname: string, toPathname: string): boolean => {
  const fromFamily = getPlannerFamily(fromPathname);
  const toFamily = getPlannerFamily(toPathname);
  return fromFamily !== null && fromFamily === toFamily;
};
